import {
  IconChevronLeft,
  IconExclamationCircle,
  IconExclamationCircleFilled,
  IconExclamationMark,
  IconX,
} from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";
import { useState } from "react";
import InputField from "../../../components/common/InputField";
import { useMerchantAllListData } from "../../../apis/merchantApis";

const receivers = [
  { name: "Ramesh Kumar", img: "/img/dummy-driver.png", assigned: true },
  { name: "Suresh Kumar", img: "/img/dummy-driver.png", assigned: false },
  { name: "Kalesh Kumar", img: "/img/dummy-driver.png", assigned: true },
  { name: "Paresh Kumar", img: "/img/dummy-driver.png", assigned: false },
  { name: "Ramesh Kumar", img: "/img/dummy-driver.png", assigned: true },
  { name: "Suresh Kumar", img: "/img/dummy-driver.png", assigned: false },
  { name: "Kalesh Kumar", img: "/img/dummy-driver.png", assigned: true },
  { name: "Paresh Kumar", img: "/img/dummy-driver.png", assigned: false },
  { name: "Ramesh Kumar", img: "/img/dummy-driver.png", assigned: true },
  { name: "Suresh Kumar", img: "/img/dummy-driver.png", assigned: false },
  { name: "Kalesh Kumar", img: "/img/dummy-driver.png", assigned: true },
  { name: "Paresh Kumar", img: "/img/dummy-driver.png", assigned: false },
];

type SwapDriverModalProps = {
  open: boolean;
  onClose: () => void;
};

const UpdatePaymentModal = ({ open, onClose }: SwapDriverModalProps) => {
  const { data: clients } = useMerchantAllListData();

  console.log(clients, "clients...........");

  const [view, setView] = useState(false);
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-[#F7F6F2] rounded-3xl w-[36rem]">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <div>
            <h2 className="text-lg font-medium text-[#212121]">
              Update Bank Details
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-full border border-[#D2D2D2]"
          >
            <IconX size={20} />
          </button>
        </div>

        <div className="p-4 space-y-4">
          <div className="flex items-start gap-2 bg-[#FBD037]/20 text-[#212121] p-4 py-2 border rounded-lg">
            <IconExclamationCircleFilled />
            <p className="text-sm text-[#212121]">
              Tips: The added payment method will be shown to the buyer during
              the transaction to accept fiat transfers.{" "}
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4 ">
            <InputField
              label="Bank Name*"
              type="text"
              placeholder="Enter Bank Name"
              value="Visa, Mastercard"
            />
            <InputField
              label="Account Holder Name*"
              type="text"
              placeholder="Enter Account Holder Name"
              value="Muhammad Wasim Akram"
            />
            <InputField
              label="Account Number *"
              className="col-span-2"
              type="text"
              placeholder="Add account number"
              value="2085101234133"
            />
            <InputField
              label="IFSC Code * "
              className="col-span-2"
              type="text"
              placeholder="Enter IFSC Code"
              value="UBIN0541234"
            />
            <InputField
              label="Branch Name * "
              className="col-span-2"
              type="text"
              placeholder="Enter Branch Name"
              value="Jhotwara Branch, Jaipur"
            />
          </div>
          <div className="flex justify-end">
            <button className="bg-[#FBD037] text-base rounded-full font-medium text-[#000000] border border-[#FBD037]  px-6 py-2 ">
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatePaymentModal;
